<template>
	<div v-if="displayDataEdit">
		<div v-if="!mode" style="display: flex; justify-content: space-between;">
			<b-button
				v-if="!mode"
				v-b-toggle="className"
				block
				class="panel-item-header-button"
			>
				<div style="display: flex">
					<span class="panel-item-header-trigger-icon" />
					<span class="panel-item-header-title">
						<h5> {{ displayDataEdit.name || 'No Milestone Name' }} </h5> 
					</span>
				</div>
			</b-button>
			<div style="margin-top: 5px;">
				<b-icon
					v-if="!displayDataEdit.actualDate"
					class="h4 mb-2"
					icon="check-circle-fill"
					style="color: #C4C4C4; margin-right: 20px;"
				/>
				<b-icon
					v-if="displayDataEdit.actualDate"
					class="h4 mb-2"
					icon="check-circle-fill"
					variant="secondary"
					style="margin-right: 20px;"
				/>
				<b-icon 
					v-b-tooltip.hover.top="formatDate(displayDataEdit.asOfDate)"
					icon="clock"
					style="margin-bottom: 0.7rem !important;"
				/>
			</div>
		</div>
		<div v-if="!mode">
			<div style="display: flex">
				<div style="flex: 1; padding: 15px;">
					<div> Projected Date </div>
					<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
					<div style="text-align: right">
						{{ displayDataEdit.projectedDate | formatDate }}
					</div>
				</div>

				<div style="flex: 1; padding: 15px;">
					<div> Actual Date </div>
					<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
					<div style="text-align: right">
						{{ displayDataEdit.actualDate | formatDate }}
					</div>
				</div>
			</div>

			<b-collapse :id="className">
				<b-container>
					<b-row> 
						<b-col>
							<b> Description </b>
							<br>
							{{ displayDataEdit.description || 'No Description' }}
						</b-col>
					</b-row>

					<b-row>
						<b-col style="height: 15px" />
					</b-row>

					<b-row> 
						<b-col>
							<b> Associated Phases </b>
						</b-col>
					</b-row>

					<b-row v-for="(phase, id) in displayDataEdit.associatedPhases" :key="id">
						<b-col>
							<div class="associated-phase">
								{{ phase }}
							</div>
						</b-col>
					</b-row>
				</b-container>
			</b-collapse>
		</div>

		<div v-if="mode">
			<b-container>
				<b-row> 
					<b-col>
						Name
						<b-form-input
							id="input-name"
							v-model="displayDataEdit.name"
							size="sm"
							placeholder=""
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						Projected Date
						<b-form-datepicker
							:id="'datepicker_milestone_projected_date_' + index"
							v-model="displayDataEdit.projectedDate"
							size="sm" 
							locale="en" 
							placeholder="No date selected"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						Actual Date
						<b-form-datepicker
							:id="'datepicker_milestone_actual_date_' + index"
							v-model="displayDataEdit.actualDate"
							size="sm" 
							locale="en" 
							placeholder="No date selected"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						Description
						<b-form-textarea
							id="input-description"
							v-model="displayDataEdit.description"
							size="sm"
							placeholder="Enter the description"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						Associated Phases
						<b-form-checkbox-group
							:id="'milestone_checkbox_group_' + index"
							v-model="displayDataEdit.associatedPhases"
							:options="options"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<b-button block style="background-color: #FFAAAA; color: #000000;" @click="remove()">
							Remove Milestone
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</div>
</template>

<script>
export default {
    name: 'MilestoneView',
	components: {},
    filters: {
		formatDate(date) {
			if (!date || date === '') return 'Not updated'
			return new Date(date).toISOString().slice(0, 10);
		}
	},
	props: {
        index: {
            type: Number,
            required: true,
        },
        data: {
            type: Object,
            required: true
        },
        mode: {
            type: Boolean,
            required: true
        }
	},   
    data() {
        return {
            className: `milestone_${this.index}_collapse`,
			editMode: false,
			displayDataEdit: {},
			options: [
				{ text: 'Planning', value: 'Planning' },
				{ text: 'Design', value: 'Design' },
				{ text: 'Construction', value: 'Construction' },
				{ text: 'Stabilization', value: 'Stabilization' },
				{ text: 'Steady-State', value: 'Steady-State' }
			]
        }
    },
    computed: {
		formatDate() {
			return date => (!date || date === '') ? `Not updated`: new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date(date.replace(/-/g, '/').replace(/T.+/, ''))) 
		}
	},
    watch: {
		displayDataEdit: {
			deep: true,
			handler() {
				this.updateData();
			},
		},
		data: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
			},
		},
        mode: {
			immediate: true,
			handler(newVal) {
				this.editMode = newVal;
			},
		}
	},
	created() {
	},
    mounted() {
	},
    methods: {
        edit() {
			this.editMode = !this.editMode;
		},
		async updateData() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const postMilestoneModelData = await this.axios.patch(
					`/assetmilestones/${this.displayDataEdit.id}`,
					this.displayDataEdit
				);
			}
		},
		async remove() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const deleteMilestoneModelData = await this.axios.delete(
					`/assetmilestones/${this.displayDataEdit.id}`
				);
				this.$emit('refresh');
			}
		},
    }
};
</script>

<style scoped>
.btn {
	border: none;
    outline: none;
}
.btn:focus {
    box-shadow: none;
	outline: none;
}
.btn:focus-visible {
    outline: 0;
    border-radius: 0;
}
.btn:hover {
    color: #fff;
    text-decoration: none;
}
.btn-secondary {
	border: none;
    outline: none;
}
.btn-secondary:focus {
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
	outline: 0;
}
.btn-secondary:hover {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: none;
}
.btn-secondary:focus-visible {
    outline: 0;
    border-radius: 0;
}
.panel-item-header-button {
    background-color: transparent;
    width: 70%;
}
.panel-item-header-title {
    bottom: 2px;
}
div.associated-phase {
    border-radius: 12px;
    border: 1px solid #000000;
    padding: 5px;
	background-color: #647882;
    color: #ffffff;
}
</style>

<style lang="scss">
</style>